module.exports = __webpack_public_path__ + "static/media/pic3@3x.3f75767d.png";